module.exports = __webpack_public_path__ + "img/tips7.f90d50cd.png";